var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tag-375"},[_c('div',{staticClass:"overlap-group-2 plusjakartasans-bold-white-12px"},[_c('div',{staticClass:"x029-2"},[_vm._v(_vm._s(_vm.x029))]),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fee-17"},[_c('div',{staticClass:"x28-47"},[_vm._v("Fee")])])
}]

export { render, staticRenderFns }